import React from "react";
import { Box } from "@mui/material";

interface AnimatedSectionProps {
  children: React.ReactNode;
  delay?: number;
  parallax?: boolean;
}

const AnimatedSection: React.FC<AnimatedSectionProps> = ({
  children,
  delay = 0,
  parallax = false,
}) => {
  // TODO: Recover from history or recreate
  return <Box>{children}</Box>;
};

export default AnimatedSection;
